
<template>
<div>
  <!--prmanent-emp ref="prementEmp" refId="prementEmp" title="상주직원 정보 입력" :items="modalItems"/>
  <out-info ref="outInfo" refId="outInfo" title="퇴실정보입력" :items="modalItems"/>
  <enter-info ref="enterInfo" title="입실정보입력" :items="modalItems" :key="uniqueKey"/-->
  <page-header title="사용자 관리" description="사용자 목록입니다.">
    <div class="btn-wrap">
      <button class="btn btn-lg light-blue" @click="create()">
        <i class="icon-plus mr-5"></i> 사용자 추가
      </button>
      <button class="btn btn-lg light-blue" @click="deleteRow()">
        <i class="icon-minus mr-5"></i> 사용자 제거
      </button>
      <button class="btn btn-lg line-2" @click="downloadExcel()">
        <i class="icon-excel mr-5"></i> 다운로드
      </button>
    </div>
  </page-header>




  <div class="page-body ph-30 book-search">
    <div class="pt-20">
      <div class="row" style="justify-content: flex-end;">
        <div class="search-item">
          <div class="input-group">
            <Dropdown title="IDC" v-model="searchItem.locationCode" displayName="locationName" valueName="locationCode" :isSelectionFirstData="true"  :datasource="idcList" inline="inline" :width="110"/>
          </div>
        </div>

        <div class="search-item">
          <div class="input-group">
            <Dropdown v-model="searchItem.userLevelCode" displayName="userLevelStr" valueName="userLevelCode" :datasource="userLevelList" title="사용자 타입" :isSelectionFirstData="true" inline="inline"/>
          </div>
        </div>
        <div class="search-item">
          <div class="input-group">
            <Dropdown v-model="searchItem.searchType" :datasource="searchTypeList" title="" :isSelectionFirstData="true" inline="inline"/>
              <input type="text" class="form-control" v-model="term">
              <!--<button type="button" class="btn btn-m search" @click="searchClick()">-->
                <!--<i class="icon-search"></i>-->
              <!--</button>-->
          </div>
        </div>

        <div class="search-item">
          <button class="btn btn-md blue ml-6 search" @click="searchClick()">검색</button>
        </div>
      </div>
    </div>



    <data-table :datasource="items" :noDataSpan="8">
      <template v-slot:header>
        <data-table-header-column name="checked" displayName="" width="50px">
          <label class="md-check">
            <input type="checkbox" @change="check" v-model="checkedAll">
            <i class="blue"></i>
          </label>
        </data-table-header-column>
        <data-table-header-column name="empName" displayName="이름" width="10%"/>
        <data-table-header-column name="empName" displayName="이메일" width="25%"/>
        <data-table-header-column name="empName" displayName="사번" width="15%"/>
        <data-table-header-column name="empType" displayName="사용자타입" width="15%"/>
        <data-table-header-column name="empName" displayName="주 IDC" width="15%"/>
        <data-table-header-column name="assetList" displayName="IDC 권한" />
        <data-table-header-column name="more" displayName="" width="50px"/>
      </template>
      <template v-if="total != 0" v-for="(item, $index) in items">
         <tr v-bind:key="$index" :class="[selectedIndex == item.empNo ? 'expanded' : null]">
          <data-table-column name="checked" displayName="" width="50px">
            <label class="md-check">
              <input type="checkbox" v-model="item.checked" @change="checkboxChange">
              <i class="blue"></i>
            </label>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="이름">{{item.employee.empName}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="" >
            <span class="td-text ellipsis" data-original-title="이메일">{{item.employee.empEmail}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="사번">{{item.empNo}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="사용자타입">{{item.userLevel.userLevelStr}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="주 IDC">{{getMainIdc(item)}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="IDC 권한">{{getIdcAuth(item)}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <a @click="itemClick(item)">
              <i :class="['icon', selectedIndex == item.empNo  ? 'icon-arrow-line-up' : 'icon-arrow-line-down']"></i>
            </a>
          </data-table-column>
        </tr>

        <UserForm :item="item" v-bind:key="'detail-'+$index" v-if="selectedIndex == item.empNo" :idcList="getFormIdcList(item)"
                  @updateRow="updateRow" :ref="'detail'+$index"/>
      </template>
    </data-table>
    <Pagenation ref="paging" :datasource="resultData" @pageChange="pageChange"/>
  </div>

</div>
</template>
<script>
import Dropdown from "@/components/Dropdown.vue"
import Pagenation from '@/components/common/Pagenation.vue';
import PageHeader from '@/layout/PageHeader.vue';
import DataTableHeaderColumn from '@/components/common/DataTableHeaderColumn.vue';
import DataTableColumn from '@/components/common/DataTableColumn.vue';
import DataTableBase from '@/components/common/dataTableBase';
import DataTable from '@/components/common/DataTable.vue';
import UserForm from './UserForm';
export default {
  mixins: [DataTableBase],
  components: {PageHeader, Dropdown, Pagenation,DataTableBase, DataTable, DataTableHeaderColumn, DataTableColumn, UserForm},
  data(){
    return {
      getApi:'user',
      paging: this.$dataProvider.paging,
      searchTypeItem: {},
      searchTypeList: [{name: '이름', value: 'empName'}, {name: '이메일', value: 'empEmail'}, {name: '사번', value: 'empNo'}],
      idcSelctedItem: null,
      idcList: null,
      formIdcList: [],
      rowItem : {title: '공지사항', user: '강선호', email: 'seonho.kang@navercorp.com', empNo: 'NB11727', empType: '시스템관리자', empLevel: '가산, 대전, 부산, 여의도, 춘천, 판교, 평촌', empMainIdc: '춘천', isChecked: false, isOpen: false, createDate: '2021-07-07', modifiedDate: '2021-07-07'},
      searchItem: {},
      term: null,
      items: [],
      total: 0,
      resultData : null,

    }
  },
  computed: {
  },
  mounted(){
    this.init();
  },
  computed: {
    getFormIdcList(){
      return (item) =>{
        if(!item.idcList && this.formIdcList){
          var idcList = this.copyNew(this.formIdcList);
          var b = item.userIdcAuthList.map(x=>x.location.locationCode);
          var defaultIdc = item.userIdcAuthList.filter(x=>x.isDefault).length > 0 ? item.userIdcAuthList.filter(x=>x.isDefault)[0].locationCode : null;
          idcList.forEach(x=>{
            if(b.includes(x.locationCode)){
              x.checked = true;
               x.isDefault = 0;
              if(x.locationCode == defaultIdc)
                x.isDefault = 1;
            }
          })
          return item.idcList = idcList;
        }else{
          return item.idcList;
        }
      }
    },
    getMainIdc() {
      return (item)=>{
        if(item.userIdcAuthList){
          var mainIdcList = item.userIdcAuthList.filter(x=>x.isDefault == 1);
          if(mainIdcList.length)
            return mainIdcList[0].location.locationName;
        }

      }
    },
    userLevelList() {
      var result = null;
      if(this.$store.getters['dropdown/dataprovider']){

        result = [{userLevelStr: '전체', userLevelCode: null}].concat(this.$store.getters['dropdown/dataprovider'].userLevel);
      }
      return result;
    },
    getIdcAuth(){
      return (item) => {
        return item.userIdcAuthList.map(x=>x.location.locationName).join(', ');
      }
    }
  },
  methods: {
    init(){
      var query = Object.assign({},this.$route.query);
      this.searchItem = query;

      this.dateRange = [moment(Number(this.searchItem.fromDate)).toDate(), moment(Number(this.searchItem.toDate)).toDate()];
      //this.$nextTick(()=>{


      this.loadIdc();
      //})
      if(!query.limit || !query.offset){
        this.$router.push({ path: this.$route.path, query: this.paging});
        this.findAll();
      }else{
        this.findAll();
      }
    },
    loadIdc(){
      var that = this;
      this.$http.get('/api/private/location/list').then((result) =>{
        var idcList = [{locationCode: null, locationName: '전체'}] //_.uniqBy(result.data.map(x=>{return {code: x.code[0], name: x.str[0]}}),  e=>e.code);
        that.formIdcList = _.uniqBy(result.data.map(x=>{return {locationCode: x.code[0], locationName: x.str[0]}}),  e=>e.locationCode);
        idcList = idcList.concat(that.copyNew(that.formIdcList));
        setTimeout(()=>{
        },1000);
        that.idcList = idcList;
      })
    },
    updateRow(data){
      this.items.forEach((x,idx)=>{
        if(x.empNo == data.empNo){
          x.userIdcAuthList = data.userIdcAuthList;
          x.userLevel = data.userLevel;

          this.$refs['detail'+idx][0].init();

          this.$forceUpdate();
          return;
        }
      })
    },
    deleteRow(){
      var deleteItems = this.items.filter(x => x.checked).map(x=>x.empNo);

      this.$http.delete('/api/private/user',{data: deleteItems}).
      then((result)=>{
        this.noti('완료', '사용자가 제거 되었습니다..', 'success');
        this.init();
        this.$forceUpdate();
      })
    },
    // downloadExcel(){
    //   var query = $.param(this.searchSetting());
    //   this.$http('/api/private/user/download?' + query).
    //   then((result)=>{
    //
    //   })
    // },


    downloadExcel(){
      var query = $.param(this.searchSetting());
      this.$http.get('/api/private/user/download', {params: query, responseType: 'blob'})
        .then(function(result) {
          const url = window.URL.createObjectURL(new Blob([result.data], {type: 'application/octet-stream'}));
          const link = document.createElement('a');
          link.href = url;

          let fileName = this.getDateFormat(new Date(), 'YYYYMMDD') +' VMS 사용자 목록.xlsx';
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }.bind(this)).catch((e) =>{
          this.noti("다운로드 실패", e.message, 'warning');
      })
    },


    create(){
      this.$router.push({ path: '/app/user', query: {mode: 'new'}})
    },
    remove(){

    },
    view(){
      this.$router.push({ path: '/app/notice', query: {mode: 'view'}})
    },
    open(item){
      var cItem = Object.assign({}, item);
      this.items.forEach((x) => {
        x.isOpen = false;

      })
      item.isOpen = !cItem.isOpen;
      if(!item.idcList)
        item.idcList = this.copyNew(this.formIdcList);
    },
    pageChange(event){
      if(event)
        this.paging = event.data;

      var query = Object.assign({},this.$route.query);
      this.searchTypeList.forEach((x) => {delete query[x.value]})
      query.limit = this.paging.limit;
      query.offset = this.paging.offset;
      this.$router.push({ path: this.$route.path, query: query});

      this.findAll();
    },
    itemClick(item){
      if(this.selectedIndex != item.empNo)
        this.selectedIndex = item.empNo;
      else
       this.selectedIndex = null;
    },
    searchSetting(){
      var query = Object.assign({},this.$route.query);

      delete query.locationCode;
      delete query.userLevelCode;
      delete query.searchType;
      this.searchTypeList.forEach(x=>{
        if(this.searchItem[x.value] != this.searchItem.searchType){
          delete this.searchItem[x.value];
        }
        query[x.value] = null;
      })
      this.searchItem[this.searchItem.searchType] = this.term;
      query = Object.assign(query, this.copyNew(this.searchItem));
      Object.keys(query).forEach(x => {
        if(query[x] == '' || query[x] == null)
          delete query[x]
      })
      return query;
    },
    searchClick(){
      var query = this.searchSetting();

      query.offset = 1;
      this.$router.push({query: query})
      setTimeout(function(){
        this.findAll();
      }.bind(this),300)
    },
  }
}
</script>

<style>

</style>
